import { render, staticRenderFns } from "./hc-footer.vue?vue&type=template&id=3acf6d3a&scoped=true&"
import script from "./hc-footer.vue?vue&type=script&lang=js&"
export * from "./hc-footer.vue?vue&type=script&lang=js&"
import style0 from "./hc-footer.vue?vue&type=style&index=0&id=3acf6d3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acf6d3a",
  null
  
)

export default component.exports